import React, { useEffect, useState, useCallback, useContext } from "react";
import {
  CircularProgress,
  Divider,
  Tooltip,
  Typography,
  Button,
  IconButton,
  Badge,
  Grid,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  FormControlLabel,
  Switch,
  DialogTitle,
} from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import CopyToClipboard from 'react-copy-to-clipboard';
import InfoIcon from '@material-ui/icons/Info';
import Modal from "../../cm_shared/cm_global_modal";
import axios from "axios";
import DataTable from "react-data-table-component";
import CloudDownloadIcon from "@material-ui/icons/CloudDownload";
import ClearIcon from "@material-ui/icons/Clear";
import options from "../PRScenarioListing/options";
import CustomPagination from "../../cm_shared/CMCustomPagination";
import { Link, withRouter } from "react-router-dom";
import CMDeleteModal from "../../cm_shared/CMDeleteModal";
import TestRunsListing from "./../TestRunsListing";
import PlayCircleFilledWhiteIcon from "@material-ui/icons/PlayCircleFilledWhite";
import DescriptionIcon from "@material-ui/icons/Description";
import ViewListIcon from '@material-ui/icons/ViewList';
import BulkDownloadModal from "../../cm_shared/CMBulkDownloadPopup/index";
import BulkDownloadConfirmationModal from "../../cm_shared/CMBulkDownloadConfirmation/index";
import HelpIcon from "@material-ui/icons/Help";
import HelperComponent from "../../cm_shared/Reporting/CustomHelper/index";
import ScenarioNamesListing from "./ScenarioNamesList";
import { LoadingContext } from "./../../../../context/spinnerContext"
import styled from "styled-components";
import { containsFctwPattern } from "../../../../helper";

const customStyles = {
  table: {
    style: {
      border: "solid 1px rgba(0,0,0,.2)",
      borderRadius: "10px",
    },
  },
  rows: {
    style: {
      minHeight: "72px",
      cursor: "pointer",
      fontSize: 16,
      paddingTop: "10px",
      paddingBottom: "10px",
      minHeight: "unset"
    },
  },
  headCells: {
    style: {
      paddingLeft: "8px",
      paddingRight: "8px",
      backgroundColor: "#b0ff45",
      justifyContent: "flex-start",
    },
  },
  cells: {
    style: {
      paddingLeft: "8px",
      paddingRight: "8px",
      fontWeight: "bold",
      justifyContent: "flex-start",
    },
  },
};

const StyledDataTable = styled(DataTable)`
  .rdt_TableBody {
    overflow: auto;
    max-height: calc(100vh - 360px)
  }
`;

const loadingStyles = makeStyles({
  wrapper: {
    width: "100%",
    height: "100%",
    position: "fixed",
    top: "0",
    left: "0",
    right: "0",
    bottom: "0",
    backgroundColor: "rgba(0,0,0,0.5)",
    zIndex: "2",
  },
  spinner: {
    position: "absolute",
    top: "50%",
    left: "50%",
  },
  fctwToggle: {
    border: '1px solid rgba(0,0,0,.2)',
    height: '56px',
    width: '135px',
    borderRadius: '5px',
    padding: '0.5rem',
    marginRight: "24px"
  }
});

function ExecutionListingOfOpenLoop(props) {
  const query = new URLSearchParams(window.location.search);
  const openLoopType=query.get("open-loop-type");
  const { setIsLoading } = useContext(LoadingContext); 
  const classes = loadingStyles();
  const [topology_id, setTopologyId] = useState(
    props.location.state && props.location.state.topology_id
      ? props.location.state.topology_id
      : ""
  );
  const type = window.location.pathname === '/reporting-mode' && props.type;
  const isReportingMode = props.isReportingMode || false;
  const [fctwSelected, setFctwSelected] = useState(false);
  const [tagName, setTagName] = useState(props.location.state && props.location.state.topology_tag_name ? props.location.state.topology_tag_name : "");
  const [loadingOverlay, setLoadingOverlay] = useState(false);

  const [isOpen, setIsOpen] = useState(false);
  const [modalContent, setModalContent] = useState(null);
  const [scenarioCollectionNew, setScenarioCollectionNew] = useState([]);
  const [columns, setColumns] = useState([]);
  const [cartItems, setCartItems] = useState([]);
  const rowsPerPageSessionBased = [
    10, 20, 50, 100, 200, 300, 500, 700, 1000, 1200, 1500, 1800, 2000, 2500,
    3000,
  ];
  const [eventsPerPage, setEventsPerPage] = useState(10);
  const [page, setPage] = useState(0);
  const [total, setTotal] = useState(0);
  const [confirmDeleteOpen, setConfirmDeleteOpen] = useState(false);
  const [deleteScenarioUuid, setDeleteScenarioUuid] = useState(null);
  const [disableEscapeKeyDown, setDisableEscapeKeyDown] = useState(false);
  const [isBulkDownloadPopupOpen, setBulkDownloadPopup] = useState(false);
  const [downloadConfirm, setDownloadConfirm] = useState(false);
  const [bulkDownloadRes, setBulkDownloadResp] = useState(null);
  const [disableBackdropClick, setDisableBackdropClick] = useState(false);
  const [currentFilters, setCurrentFilters] = useState({});
  const [selectedRows, setSelectedRows] = useState([]);
  const [clearRows, setClearRows] = useState(false);
  const [dialogOpen, setDialogOpen] = useState(false);
  const [dialogMessage, setDialogMessage] = useState("");
  const [sortField, setSortField] = useState("");
  const [sortOrder, setSortOrder] = useState("");
  const [currentRowSelection, setCurrentRowSelection] = useState(null);
  const onSelectRow = async (newRow, deSelect = false) => {
    if (deSelect) {
      const index = selectedRows.findIndex(
        (row) => row.scheduler_uuid === newRow.scheduler_uuid
      );
      const newArray = [
        ...selectedRows.slice(0, index),
        ...selectedRows.slice(index + 1),
      ];
      setSelectedRows(newArray);
    } else setSelectedRows((prev) => [...prev, newRow]);
  };

  const selectAll = async (allRow, currentRow) => {
    const newArray = selectedRows.filter(
      (item1) =>
        !currentRow.some(
          (item2) => item2.scheduler_uuid === item1.scheduler_uuid
        )
    );
    setSelectedRows([...newArray, ...allRow]);
  };

  const deselectAll = async (currentRow) => {
    const newArray = selectedRows.filter(
      (item1) =>
        !currentRow.some(
          (item2) => item2.scheduler_uuid === item1.scheduler_uuid
        )
    );
    setSelectedRows([...newArray]);
  };

  const bulkDownload = async () => {
    setDownloadConfirm(false);
    try {
      setIsLoading(true);
      const payload = selectedRows.map(item => {
        return {'file': item.file_path};
      })
      const resp = await axios.post(
        process.env.REACT_APP_API_GATEWAY_URL+"/bulk-download",
        payload
      );
      setBulkDownloadResp(JSON.parse(resp.data));
      setBulkDownloadPopup(true);
    } catch(err) {
      console.log('err', err);
    } finally {
      setIsLoading(false);
      setClearRows(!clearRows);
      setSelectedRows([]);
    }
  };

  const onCloseBulkDownloadPopup = () => {
    setBulkDownloadPopup(false);
    console.log(window.location);
    if (bulkDownloadRes.statusCode === 200) {
      const match = bulkDownloadRes.body.match(/download-(\d+)/);
      window.open(`${window.location.origin}/download_archive_list?latestDownload=${match[0]}`, '_blank');
    }
  }
  const reportStatus=(row)=>{
    let apiUrl;
    if (isReportingMode) {
      type === 'pg' ?
        apiUrl = "cm/reporting-mode/cad-reporting-status" :
        apiUrl = "/cm/pr-reporting-mode/cad-reporting-status"
    } else apiUrl = "/cm_open_loop/fetch_execution_report_status"
    return axios.post(
      apiUrl,
      {
        reporting_id: isReportingMode ? row.cad_uuid : row.execution_uuid,
        reporting_level: isReportingMode ? 'cad_level' : "execution_id",
        reporting_type: isReportingMode ? type.toUpperCase() : row.open_loop_type,
      }
    );
  }
  const handleViewReport = (row) => {
    // const isFctw = true ; // for fctw data
    // const isFctw = containsFctwPattern(`${row.execution_uuid} ${row.tag_name.join(",")}`) ;
    // console.log("isFctw", isFctw)
    let reportUrl;
    if (row && row.open_loop_type === "PR") {
      reportUrl = `/PR_Report_Screen/overall?page=open_loop&reporting_level=execution_id&execution_id=${row.execution_uuid}`;
    } else {
      if (isReportingMode) {
        type === 'pg' ?
        reportUrl = `/reporting?page=open_loop&mode=reporting&reporting_level=execution_id&execution_id=${row.cad_uuid}` :
        reportUrl = `/PR_Report_Screen/overall?page=open_loop&mode=reporting&reporting_level=execution_id&execution_id=${row.cad_uuid}`;
      }
      else reportUrl = `/reporting?page=open_loop&reporting_level=execution_id&execution_id=${row.execution_uuid}`;
    }
    window.open(reportUrl, "_blank");
  };

  const handleDialogClose = () => {
    setDialogOpen(false);
  };

  const handleFctwToggle = (event) => {
    setFctwSelected(event.target.checked);
    setPage(0);
  }

  const viewReportPrecheck = async (row) => {
    try {
      setIsLoading(true);
      const response = await reportStatus(row)
      if (!response.data.status || response.data.status.toLowerCase() !== "completed") {
        setDialogOpen(true);
        setDialogMessage(
          !response.data.status?"Issue occurred, please connect with your admin.":
          `Execution status - ${response.data.status}`);
        return
      } 
       handleViewReport(row);
    } catch (error) {
      setDialogOpen(true);
      if (error.response && error.response.data && error.response.data.status)
        setDialogMessage("Execution status - " + error.response.data.status);
      else setDialogMessage("Issue occurred, please connect with your admin.");
    } finally {
      setIsLoading(false);
    }
  };

  const generateReportPrecheck = async (row) => {
    try {
      setIsLoading(true);
      const response =await reportStatus(row);
      if (response.data.status && response.data.status.toLowerCase() === "started") {
        setDialogOpen(true);
        setIsLoading(false);
        setDialogMessage(
          `Report execution was in progress`);
        return
      } 
      handleGenerateReport(row);
    } catch (error) {
      setDialogOpen(true);
      setIsLoading(false);
      if (error.response && error.response.data && error.response.data.status)
        setDialogMessage(`Report execution was in ${error.response.data.status} status`);
      else setDialogMessage("Issue occurred, please connect with your admin.");
    }
  };

  const handleGenerateReport = async (row) => {
    setIsLoading(true);
    const isFctw = !isReportingMode ?
    containsFctwPattern(`${row.execution_uuid} ${row.tag_name.join(",")}`) :
    containsFctwPattern(`${row.cad_uuid} ${row.cad_tag_name}`);
    const awsUrl = isFctw ? process.env.REACT_APP_REPORTING_OPEN_LOOP_FCTW_LAMBDA_URL :
    process.env.REACT_APP_REPORTING_OPEN_LOOP_DECIDER_LAMBDA_URL;
    try {
      const response = await axios.post(
        awsUrl,
        isReportingMode ? {
          cad_uuid: row.cad_uuid,
          mode: "reporting",
          cad_tag_name: row.cad_tag_name,
          type: type === 'pg' ? "PG" : "PR",
          reporting_level: "cad_level"
        } : { ...row, reporting_level: "execution_id" },
        {
          headers: {
            "Content-Type": "application/json",
          },
        }
      );
      setDialogMessage("Report generation has started successfully. Your report will be available shortly.");
    } catch (error) {
      console.error("Error generating report:", error);
      setDialogMessage("Failed to generate report.");
    } finally {
      setIsLoading(false);
      setDialogOpen(true);
    }
  };
  const handleDownload = async (filePath) => {
    const fileToDownload = await axios.post("/generate-presigned-url", {
      s3_location: filePath,
    });
    window.open(fileToDownload.data.presigned_url);
  };
 
  const handleSort = (column, direction) => {
    setCurrentRowSelection(null)
    setSortField(column.selector);
    setSortOrder(direction);
  };

  const handleViewScenarios = async (rowData) => {
    const response = await axios.post(type === 'pg' ?
      "/cm/reporting-mode/cad-scenario-name-list" :
      "/cm/reporting-mode/pr-cad-scenario-name-list ", {
      cad_uuid: rowData.cad_uuid	,
    });
    console.log('response', response);
    handleModal(
      <ScenarioNamesListing
        list={response.data.scenario_names}
        uuid={response.data.cad_uuid}
        tagName={rowData.cad_tag_name}
        closeDailog={setIsOpen}/>,
      true,
      true
    )
  }

  // let initialColumns = [
  //   {
  //     name: "Execution ID",
  //     selector: isReportingMode ? "cad_uuid" : "execution_uuid",
  //     sortable: true,
  //     reorder: true,
  //     width: '380px',
  //     cell: (row) => {
  //       return (
  //         <span>{isReportingMode ? row.cad_uuid : row.execution_uuid}</span>
  //       )
  //     }
  //   }]

    
  let initialColumns = [
    {
      name: "Topology Tag Name",
      selector: isReportingMode ? "cad_tag_name" : "tag_name",
      sortable: true,
      grow: 3,
      cell: (row) => {
        // console.log("ROW INSIDE EXECUTION LISTING", row, typeof row.tag_name, Object.keys(row.tag_name))
        if (isReportingMode) {
          return (
            <div style={{ display: "flex"}}>
              <span>{row.cad_tag_name}</span>
              <span><Tooltip placement="top" title={<h6>{row.cad_uuid}</h6>}>
              <CopyToClipboard text={row.cad_uuid}><InfoIcon style={{
                marginTop: '-3px',
                marginLeft: '0.5rem',
                color: 'rgba(0, 0, 0, 0.54)'
              }}/></CopyToClipboard>
              </Tooltip></span>
            </div>
          )
        }
        else {
          if (typeof row.tag_name === "string") {
          return (
            <>
              {row.tag_name}<Tooltip placement="top" title={<h6>{row.execution_uuid}</h6>}>
              <CopyToClipboard text={row.execution_uuid}><InfoIcon style={{
                marginTop: '-3px',
                marginLeft: '0.5rem',
                color: 'rgba(0, 0, 0, 0.54)'
              }}/></CopyToClipboard>
              </Tooltip>
            </>
          )
          }
          else {
            return (
              <>
                {(row.tag_name).map((tag) => {
                  return (
                    <div style={{ display: "flex"}}>
                    <span>{tag}</span>
                    <span>
                      <Tooltip placement="top" title={<h6>{row.execution_uuid}</h6>}>
                        <CopyToClipboard text={row.execution_uuid}><InfoIcon style={{
                        marginTop: '-3px',
                        marginLeft: '0.5rem',
                        color: 'rgba(0, 0, 0, 0.54)'
                      }}/></CopyToClipboard>
                      </Tooltip>
                    </span>
                    </div>
                  )
                })}
              </>
            )
  
          }
        }
      }
    },
  ]

  // let restColumns = [
  //   {
  //     name: "Tag Name",
  //     selector: isReportingMode ? "cad_tag_name" : "tag_name",
  //     sortable: true,
  //     reorder: true,
  //     cell: (row) => {
  //       // console.log("ROW INSIDE EXECUTION LISTING", row, typeof row.tag_name, Object.keys(row.tag_name))
  //       if (isReportingMode) {
  //         return (
  //           <>
  //             {row.cad_tag_name}
  //           </>
  //         )
  //       }
  //       else {
  //         if (typeof row.tag_name === "string") {
  //         return (
  //           <>
  //             {row.tag_name}
  //           </>
  //         )
  //       }
  //       else {
  //         return (
  //           <div style={{ display: "flex", justifyContent: "center", flexDirection: "column", minHeight: "120px" }}>
  //             {(row.tag_name).map((tag) => {
  //               return (
  //                 <div>{tag}</div>
  //               )
  //             })}
  //           </div>
  //         )
  //       }
  //     }
  //     }
  //   },
  // ];

  const restCols = [
    {
      name: "Last Updated At",
      selector: "updated_at",
      sortable: true,
      cell: (row) => {
        return <div>{row.updated_at}</div>
      }
    },
    {
      name: "Actions",
      selector: "actions",
      sortable: false,
      cell: (row) => (
        <div style={{ display: "flex" }}>
          {isReportingMode && <Tooltip placement="top" title={<h6>View Scenario Names</h6>}>
            <IconButton
              aria-label="view"
              style={{padding: "7px" }}
              onClick={() => handleViewScenarios(row)}
            >
              <ViewListIcon />
            </IconButton>
          </Tooltip>}
          <Tooltip placement="top" title={<h6>Generate Report</h6>}>
            <IconButton
              aria-label="delete"
              onClick={() => generateReportPrecheck(row)}
              style={{ padding: "7px" }}
            >
              <PlayCircleFilledWhiteIcon />
            </IconButton>
          </Tooltip>
          <Tooltip placement="top" title={<h6>View Report</h6>}>
            <IconButton
              onClick={() => viewReportPrecheck(row)}
              style={{ padding: "7px" }}
            >
              <DescriptionIcon />
            </IconButton>
          </Tooltip>
        </div>
      ),
    },
  ];

  if (tagName !== "") {
    console.log("FOUND TAG NAME", tagName)
    initialColumns = [...initialColumns, {
      name: "Count",
      selector: "test_run_id_count",
    },
    {
      name: "Model",
      selector: "model_name",
      sortable:true,
      cell: (row) => {
        return <div>{row.model_name}</div>
      }
    },
    {
      name: "Started By",
      selector: "updated_by",
      sortable:true,
      cell: (row) => {
        return <div>{row.updated_by}</div>
      }
    },
    ...restCols]
  } else if (isReportingMode) {
    initialColumns = [...initialColumns, {
      name: "Description",
      selector: "cad_description",
      grow: 2,
      cell: (row) => (
        <div style={{ display: "flex" }}>
          {row.cad_description && row.cad_description.length > 49 ?
          <Tooltip placement="top" title={<h6>{row.cad_description}</h6>}>
            <span>{`${row.cad_description.substring(0, 49)}....`}</span>
          </Tooltip> :
          <span>{row.cad_description}</span>
          }
        </div>
      )
    },
    ...restCols]
  }
  else {
    initialColumns = [...initialColumns,
      {
        name: "Model",
        selector: "model_name",
        sortable:true,
        cell: (row) => {
          return <div>{row.model_name}</div>
        }
      },
      {
        name: "Started By",
        selector: "updated_by",
        sortable:true,
        cell: (row) => {
          return <div>{row.updated_by}</div>
        }
      },
    ...restCols]
  }
  const handleResetForm = () => {
    setTopologyId("");
    window.history.replaceState({}, "");
    setColumns(initialColumns);
    setEventsPerPage(10);
    setPage(0);
  };

  const generateFilterColumns = (filters) => {
    if (!filters || !Array.isArray(filters)) {
      return [];
    }

    return filters.flatMap((filterGroup) => {
      return Object.keys(filterGroup)
        .map((filterKey) => {
          const filterValues = filterGroup[filterKey];

          if (options[filterKey]) {
            return {
              name: options[filterKey].props.label,
              selector: options[filterKey].selector,
              sortable: true,
              reorder: true,
            };
          }

          return null;
        })
        .filter((column) => column !== null);
    });
  };

  const handleModal = (content, disableBackdropClick, disableEscapeKeyDown) => {
    setDisableBackdropClick(disableBackdropClick ? true : false);
    setDisableEscapeKeyDown(disableEscapeKeyDown ? true : false);
    setModalContent(content);
    setIsOpen(true);
  };

  const handleChangeRowsPerPage = (event) => {
    setEventsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  const handlePageChange = (event, newPage) => {
    setPage(newPage);
  };

  const fetchScenarioCollectionNew = async () => {
    try {
      setIsLoading(true);
      let response;
      if (topology_id !== "") {
        response = await axios.post(
          "/cm_open_loop/topology/fetchexecutionsbyTopology",
          {
            topology_id: topology_id,
            tag_name: tagName,
            page_size_record: eventsPerPage,
            page_number_record: page + 1,
          }
        );
      } else {
        response = await axios.post(`/cm_open_loop/fetch_topology_executions`, {
          page_number_record: page + 1,
          page_size_record: eventsPerPage,
          open_loop_type:openLoopType?openLoopType.toUpperCase():null,
          fctw:fctwSelected,
          sort_field_record: sortField,
          sort_order_record: sortOrder
        });
      }

      setScenarioCollectionNew(response.data.data);
      setTotal(response.data.total_records);
    } finally {
      setIsLoading(false);
    }
   
  };

  const fetchReportingModeExecutions = async() => {
    const response = await axios.post(
      type === "pg" ? "cm/reporting-mode/cad-listing-pg" : "cm/reporting-mode/pr-cad-listing",
      {
        page_number_record: page + 1,
        page_size_record: eventsPerPage,
        model_version: props.selectValue,
        ...(type === 'pg') && {fctw: fctwSelected}
      }
    );
    setScenarioCollectionNew(response.data.data);
    setTotal(response.data.total_records);
  }

  useEffect(() => {
    if (isReportingMode && props.selectValue) fetchReportingModeExecutions();
    else fetchScenarioCollectionNew(currentFilters);
  }, [eventsPerPage, page, topology_id, props.selectValue, fctwSelected,sortField, sortOrder]);

  useEffect(() => {
    setColumns(initialColumns);
  }, [cartItems]);

  const handleDelete = async (scenarioUuid) => {
    try {
      await axios.post(`/cm/close_loop/delete-carmaker-scenario`, scenarioUuid);
      fetchScenarioCollectionNew();
    } catch (error) {
      console.error("Failed to delete the scenario:", error);
    } finally {
      setConfirmDeleteOpen(false);
    }
  };

  return (
    <div
      style={{
        padding: "0.6rem",
        padding: "0.6rem",
        position: "relative",
        background: "white",
        margin: isReportingMode ? "10px 0 0 0" : "10px",
        borderRadius: "10px",
        height: "calc(100% - 120px)",
      }}
    >
      {loadingOverlay && (
        <div className={classes.wrapper}>
          <CircularProgress size={50} className={classes.spinner} />
        </div>
      )}
      {!isReportingMode && <div
        style={{
          display: "flex",
          justifyContent: "space-between",
          backgroundColor: "white",
          padding: "5px",
          width: "100%",
        }}
      >
        <Typography variant="h5">
          <Link to="/welcome">Open Loop </Link>
          {">"} Execution Listing {">"} {openLoopType && openLoopType.toUpperCase()}
        </Typography>

        <div>
          <Tooltip placement="top" title={<h6>Help</h6>}>
            <IconButton
              color="inherit"
              onClick={() =>
                handleModal(
                  <HelperComponent
                    closeHandler={setIsOpen}
                    contentController={[
                      {
                        value: "tutorialVideo",
                        label: "Tutorial",
                        tutorials: [{
                        videoURL: "/video/openloopExecution.mp4",
                        text: "In this tutorial, we will have a walkthrough on how to use the open loop execution.",
                        title: "Open loop | Execution Listing"},{
                        videoURL:"/video/executionListing.mp4",
                        text:"In this tutorial, we will have a walkthrough on how to use the report based on both execution and test level for PG.",
                        title: "Open loop | Execution Listing for PG"  
                        },{
                          videoURL:"/video/openloopprlisting.mp4",
                          text:"In this tutorial, we will have a walkthrough on how to use the report based on both execution and test level for PR.",
                          title: "Open loop | Execution Listing for PR"  
                          }]
                      },
                    ]}
                    defaultSelector="tutorialVideo"
                  />,
                  true,
                  true
                )
              }
            >
              <Badge max={5000} color="secondary">
                <HelpIcon />
              </Badge>
            </IconButton>
          </Tooltip>

          {selectedRows.length !== 0 && (
            <Tooltip placement="top" title={<h6>Download</h6>}>
              <IconButton color="inherit" onClick={() => setDownloadConfirm(true)}>
                <Badge
                  badgeContent={selectedRows.length}
                  max={5000}
                  color="secondary"
                >
                  <CloudDownloadIcon />
                </Badge>
              </IconButton>
            </Tooltip>
          )}
        </div>
      </div>}
      {!isReportingMode && <Divider />}

      <Modal
        isOpen={isOpen}
        setIsOpen={setIsOpen}
        content={modalContent}
        size={isReportingMode ? "sm" : "lg"}
        disableEscapeKeyDown={disableEscapeKeyDown}
        disableBackdropClick={disableBackdropClick}
      />
      {isBulkDownloadPopupOpen && <BulkDownloadModal
        title={"Bulk Download Status"}
        isOpen={isBulkDownloadPopupOpen}
        onClosePopup={onCloseBulkDownloadPopup}
        content={bulkDownloadRes.body}
      />}
      {downloadConfirm && <BulkDownloadConfirmationModal
        isOpen={downloadConfirm}
        onClosePopup={setDownloadConfirm}
        onClickYes={bulkDownload}
      />}
      {topology_id !== "" && !isReportingMode && (
        <Grid
          container
          spacing={3}
          style={{
            margin: "16px 0 0 0",
            fontWeight: 400,
            fontSize: "16px",
            backgroundColor: "white",
            border: "solid 1px rgba(0,0,0,.2)",
            borderRadius: "10px",
            padding: "10px",
            width: "100%",
          }}
        >
          <h5>Topology Details</h5>
          <Grid container spacing={3} style={{ marginTop: "10px" }}>
            <Grid item xs={2}>
              Topology Tag Name
            </Grid>
            <Grid item xs={3}>
              {props.location.state.topology_tag_name}
            </Grid>
          </Grid>
        </Grid>
      )}
      <Grid
        container
        spacing={3}
        style={{
          marginTop: "5px",
          marginBottom: "5px",
          justifyContent: "space-between",
        }}
      >

        <Grid item>
        {openLoopType === 'PG' && !topology_id && <FormControlLabel
            className={classes.fctwToggle}
            value="start"
            control={
              <Switch
                checked={fctwSelected}
                onChange={handleFctwToggle}
                color="primary"
                name="fctw"
              />
            }
            label="FCTW"
            labelPlacement="start"
          />}

          {topology_id && !isReportingMode && (
            <Button
              onClick={handleResetForm}
              variant="outlined"
              startIcon={<ClearIcon />}
              color=""
            >
              Clear
            </Button>
          )}
    
        </Grid>
        <Grid item style={{ marginTop: isReportingMode && "-5.5rem" }}>
          <CustomPagination
            total={total}
            rowsPerPageOptions={rowsPerPageSessionBased}
            eventsPerPage={eventsPerPage}
            page={page}
            handleChangeRowsPerPage={handleChangeRowsPerPage}
            onPageChange={handlePageChange}
          />
        </Grid>
      </Grid>
      <Grid
        container
        spacing={3}
        style={{
          marginTop: "-3rem",
          marginBottom: "1.5rem",
          justifyContent: "start",
        }}
      >
      <Grid item>
      {isReportingMode && type === 'pg' && <FormControlLabel
          style={{
           border: '1px solid rgba(0,0,0,.2)',
           height: '40px',
           width: '135px',
           borderRadius: '5px',
           padding: '0.5rem'
          }}
           value="start"
           control={
             <Switch
               checked={fctwSelected}
               onChange={handleFctwToggle}
               color="primary"
               name="fctw"
             />
           }
           label="FCTW"
           labelPlacement="start"
        />}
        </Grid>
        </Grid>
      <div style={{ overflowX: "auto", marginTop: isReportingMode && "-2rem" }}>
        {columns.length > 0 ? (
          <StyledDataTable
            columns={columns}
            data={scenarioCollectionNew}
            customStyles={customStyles}
            onSort={handleSort}
            sortServer
            onRowClicked={(row) => setCurrentRowSelection(row)}
            expandableRowExpanded={(rowex) => (rowex === currentRowSelection)}
            onRowExpandToggled={(bool, row) => setCurrentRowSelection(row)}
            expandableRowsComponent={
              <TestRunsListing
                isReportingMode={isReportingMode}
                type={type}
                selectedRows={selectedRows}
                onSelectRow={onSelectRow}
                onSelectAllRow={selectAll}
                onDeselectAllRow={deselectAll}
                clearRows={clearRows}
              />
            }
            expandableRows={isReportingMode ? false : true}
          ></StyledDataTable>
        ) : null}

        <CMDeleteModal
          open={confirmDeleteOpen}
          message="Are you sure you want to delete this scenario?"
          onCancel={() => setConfirmDeleteOpen(false)}
          onConfirm={() => handleDelete(deleteScenarioUuid)}
        />

        <Dialog
          open={dialogOpen}
          onClose={handleDialogClose}
          aria-labelledby="dialog-title"
          aria-describedby="dialog-description"
        >
          <DialogTitle id="dialog-title">API Response</DialogTitle>
          <DialogContent>
            <DialogContentText id="dialog-description">
              {dialogMessage}
            </DialogContentText>
          </DialogContent>
          <DialogActions>
            <Button onClick={handleDialogClose} color="primary">
              Close
            </Button>
          </DialogActions>
        </Dialog>
      </div>
    </div>
  );
}

  export default withRouter(ExecutionListingOfOpenLoop);
